"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M8.465 19.778a1 1 0 0 1-1.415 0L4.222 16.95a1 1 0 0 1 0-1.414L12 7.757a1 1 0 0 1 1.414 0l2.829 2.829a1 1 0 0 1 0 1.414l-7.778 7.778Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M7.082 7.082c-.657-.657-.195-1.777.732-1.775l9.814.023a1.046 1.046 0 0 1 1.043 1.043l.022 9.813c.002.927-1.118 1.389-1.775.732L7.082 7.082Z"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=ThickDiagonalArrowIcon24.js.map